export default [
    {
        path: '/claims/pending',
        name: 'claims-pending',
        component: () => import('../../pages/claims/PendingPage.vue'),
        meta: {
            title: 'Claims Pending',
            requiresAuth: true,
        },
    },
    {
        path: '/claims/history',
        name: 'claims-history',
        component: () => import('../../pages/claims/HistoryPage.vue'),
        meta: {
            title: 'Claims History',
            requiresAuth: true,
        },
    },
]
